exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hints[data-v-68c5ae6f]{font-size:14px}", ""]);

// exports
